import React, { Suspense } from 'react';
import { FormattedMessage } from 'react-intl';
import { DelayedFallback } from 'common/components';
import Messages from 'i18n/messages/common';
import { SIZE_LARGE } from 'static/Constants';

const SuspenseLoading = ({
  children,
  fallback,
  size = SIZE_LARGE,
  tip = <FormattedMessage {...Messages.loading} />,
  ...props
}) => {
  const defaultFallback = <DelayedFallback size={size} tip={tip} />;

  return (
    <Suspense fallback={fallback || defaultFallback} {...props}>
      {children}
    </Suspense>
  );
};

export default SuspenseLoading;
